// extracted by mini-css-extract-plugin
export default {"linha":"Linha_linha__ZsIOC","linha__trash":"Linha_linha__trash__A2geG","linha__container":"Linha_linha__container__eOkOY","linha--concluida":"Linha_linha--concluida__9+79Q"};